import { effects as effectsV1 } from '../../effects';
import { ProductManualRecommendationEffects } from './product-manual-recommendation.effects';
import { ProductRecommendationEffects } from './product-recommendation.effects';

export const effects: any[] = [ProductRecommendationEffects, ProductManualRecommendationEffects, ...effectsV1];
